import actionItemTile from './action-item-tile';
import soxTile from './sox-tile';
import litmosTile from './litmos-course-tile'
import pendingApprovalsTile from './pending-approvals-tile'
import {expiringCertifications} from './sitedocs-tiles';


export default function () {
    return new Promise(resolve => {
        const tiles = [
            actionItemTile(),
            litmosTile(),
            expiringCertifications(),
            pendingApprovalsTile()
        ];
        Promise.all(tiles)
            .catch(error => console.error(`Error Occurred while loading tiles ${error}`))
            .finally(_ => {
                console.debug("Tiles Loaded");
                resolve();
            });
    });
}